import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';

import { AllowedIpPrivileges } from '../models/allowed-ip-privileges';
import { AllowedIpRegisterOptions } from '../models/allowed-ip-register-options';
import { AllowedIpRegisterListItem } from '../models/allowed-ip-register-results.model';

import { selectQuickFilters } from '../state/allowed-ip-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-allowed-ip-register-view',
   styleUrls: ['./allowed-ip-register-view.component.scss'],
   templateUrl: './allowed-ip-register-view.component.html',
   standalone: false,
})
export class AllowedIpRegisterViewComponent extends EntityRegisterView<
   AllowedIpRegisterListItem,
   AllowedIpRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }

   @Input() bannedallowedIpPrivileges: AllowedIpPrivileges;

   @Output() deleteAllowedIp = new EventEmitter<{
      allowedIpAddressId: number;
      ipAddress: string;
   }>();

   @Output() edit = new EventEmitter<AllowedIpRegisterListItem>();

   getRouterLink(id: number) {
      return ``;
   }

   onEditClick(entity: AllowedIpRegisterListItem) {
      this.edit.emit(entity);
   }

   onRowClick(entity: AllowedIpRegisterListItem) {
      this.onEditClick(entity);
   }

   onDeleteClick(allowedIpAddressId: number, ipAddress: string): void {
      this.deleteAllowedIp.emit({
         allowedIpAddressId,
         ipAddress: ipAddress ?? '',
      });
   }
}
